module.exports = __webpack_public_path__ + "img/instagram.a834b17b.svg";